<template>
    <div style="height: 100%;width: 100%;">
        <van-nav-bar title="顾客交易历史" left-text="返回" left-arrow fixed @click-left="historyBack"/>
        <el-table :data="cardtranhistorys" border style="width: 100%;margin-top: 45px" height="calc(100% - 45px)" size="mini">
            <el-table-column prop="billtype"    label="单据类型"width="80">
                <template slot-scope="scope">
                      {{$getBillName(scope.row.trantype)}}
                </template>
            </el-table-column>
            <el-table-column prop="projectname" label="项目名称"></el-table-column>
            <el-table-column prop="accountdate" label="日期" width="90">
              <template slot-scope="scope">
                {{$moment(scope.row.accountdate).format("YYYY-MM-DD")}}
              </template>
            </el-table-column>
            <!--<el-table-column prop="amount"      label="金额" ></el-table-column>-->
          </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cardtranhistorys:[],
                checked:true,
                storeid:"",
                cardid:"",
            }
        },
        created: function () {
            this.cardid=this.$route.query.cardid;
            this.storeid=localStorage.getItem("storeid");
            this.getBeautyCardTranHistory();
        },
        methods:{
            
            getBeautyCardTranHistory(){
                this.$post("beautymanager/getBeautyCardTranHistory",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.cardtranhistorys=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/beauty/beautycardtran.vue